import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum ItemTemplatesSearchResultFields {
	searchById = 'searchResultByItemId',
	searchByName = 'searchByName'
}

export enum ItemTemplatesSearchCompanyFields {
	searchByCompanyId = 'searchByCompanyId',
	searchByCompanyName = 'searchByCompanyName'
}

export enum ItemTemplateFilterFields {
	productCategory = 'productCategory',
	chargeType = 'chargeType',
	includeInactive = 'includeInactive'
}

export declare namespace ItemTemplate {
	interface Basic extends Entity {
		companyName: string
		item: Entity
		serviceSite: Entity
		isActive: boolean
		isTurkish: boolean
	}

	interface TreatmentMethod {
		name: string
		percent: number
	}

	interface ItemPrice {
		price: number
		formula: string
		unitOfMeasure: string
		currency: string
	}

	interface ItemInfo extends Pick<Basic, 'companyName' | 'serviceSite'> {
		companyName: string
		serviceSite: Entity
		product: string
		productCategory: string
		productType: string
		productState: string
		chargeType: string
		treatmentMethods: TreatmentMethod[]
		container: string
		itemRefCode: string
		customBillFreqCode: string
		companyCategory: string
		prefillInfo: boolean
		itemPrice: ItemPrice[]
		suppliers: Entity[]
		supplierCost: ItemPrice[]
		dependentItems: Entity[]
		wastestreamName: string
		serviceSiteProgramName: BasicString
	}

	type TableRows = {
		[value: string]: {
			label: string
			render: (
				value: (Entity & Entity[] & ItemTemplate.ItemPrice & string & boolean) | never
			) => string
			key: string
		}
	}

	namespace Form {
		interface Basic {
			itemId: number
			name: string
			isActive: boolean
			isGenericTemplate: boolean
			copyServiceSite: boolean
			copyProduct: boolean
			copyProductState: boolean
			copyContainer: boolean
			copyItemRefCode: boolean
			copyCustomBillFreqCode: boolean
			copyCompanyCategory: boolean
			copyPrebillInfo: boolean
			copyServiceSchedule: boolean
			copyItemPrice: boolean
			copySupplier: boolean
			copySupplierCost: boolean
			copyDependentItem: boolean
			copyWastestream: boolean
			copyServiceSiteProgram: boolean
		}

		interface ReadOnlyFields {
			companyName: string
			productCategory: string
			productType: string
			chargeType: string
			treatmentMethods: string
		}

		interface Add extends Omit<Basic, 'itemId'> {
			itemId: LabelValue<number> | null
			companyName: string
			productCategory: string
			productType: string
			chargeType: string
		}

		interface AddForTurkishUsers
			extends Omit<Omit<Add, 'copyPrebillInfo'>, 'copyServiceSchedule'> {}

		interface BasicRowId extends Basic {
			id: number
			item: Entity
		}

		interface Table {
			key: string
			label: string
			value: string
		}
	}

	interface FilterConfig {
		[ItemTemplateFilterFields.productCategory]: ConfigFilterItem<string, string>
		[ItemTemplateFilterFields.chargeType]: ConfigFilterItem<string, string>
		[ItemTemplateFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
	}

	namespace Search {
		interface Config {
			[ItemTemplatesSearchResultFields.searchById]: ConfigItem<ItemTemplatesSearchResultFields>
			[ItemTemplatesSearchResultFields.searchByName]: ConfigItem<ItemTemplatesSearchResultFields>
		}

		interface BasicResult {
			[ItemTemplatesSearchResultFields.searchById]: Entity[]
			[ItemTemplatesSearchResultFields.searchByName]: Entity[]
			[ItemTemplatesSearchCompanyFields.searchByCompanyId]: Entity[]
			[ItemTemplatesSearchCompanyFields.searchByCompanyName]: Entity[]
		}

		namespace Company {
			interface Config {
				[ItemTemplatesSearchCompanyFields.searchByCompanyId]: ConfigItem<ItemTemplatesSearchCompanyFields>
				[ItemTemplatesSearchCompanyFields.searchByCompanyName]: ConfigItem<ItemTemplatesSearchCompanyFields>
			}

			interface Result extends BasicResult {}
		}
	}
}
